import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-browser-reload-dialog',
  templateUrl: './browser-reload-dialog.component.html',
  styleUrls: ['./browser-reload-dialog.component.scss'],
  standalone: false
})
export class BrowserReloadDialogComponent implements OnInit {
  counter = 60;
  constructor(
    public dialogRef: MatDialogRef<BrowserReloadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public subheader: string
  ) {}

  ngOnInit(): void {
    setInterval(() => {
      this.counter -= 1;
      if (this.counter == 0) {
        window.location.reload();
      }
    }, 1000);
  }

  get hasSubheader(): boolean {
    return !!this.subheader;
  }

  reloadBrowser() {
    window.location.reload();
  }
}
